export const sizes = {
  buttons: {
    xs: '24px',
    sm: '28px',
    md: '32px',
    lg: '36px'
  }
} as const
